import(/* webpackMode: "eager" */ "/app/nettleworth-frontend/src/app/(charts)/profile/page.js");
